jQuery(document).ready(function(){
  
  // create a session when click on wholsesale collection
   jQuery('.wholesalecollections').on('click',function() {

        var collection_name = jQuery(this).attr('data-collection');

        if (collection_name) {
            sessionStorage.setItem('selected_collection', collection_name);
        }
    });

    var collectionName = sessionStorage.getItem('selected_collection');

    // Remove session on home page          
    if (collectionName !== null && jQuery('#shopify-section-template--18781532651808__custom_home_page').length > 0) {
        sessionStorage.removeItem('selected_collection');
    }
    if (collectionName !== null && jQuery('#shopify-section-template--18781533012256__custom_home_page').length > 0) {
        sessionStorage.removeItem('selected_collection');
    }
    
    // Remove price if session Exists
    if (collectionName !== null) {
       jQuery('.custom-coll-price').remove();
    }
   
   // Remove price if session Exists
    if (collectionName !== null) {
       jQuery('.custom_coll_price').remove();
    }else{
        jQuery('.custom_get_quote_btn').remove();
        jQuery('.custom_coll_call').remove();
        
    }
//add banner in products page
    var list = $("#product-grid");
    var listItems = list.find("li");
    var htmlContent = jQuery('#shopify-section-template--18781532619040__two_blocks').html();
    jQuery('#shopify-section-template--18781532619040__two_blocks').remove();

    for (var i = 7; i < listItems.length; i += 8) {
      jQuery(listItems[i]).after(htmlContent);
    }
// Search bar
jQuery('.custom_seacrh').on('input', function() {
        var searchText = jQuery(this).val().toLowerCase();
        var $listItems = jQuery('ul.all_product-lists li');
        var selectedCategory = jQuery('#caategory-search').val();

         var anyMatched = false;

        if (searchText.length >= 3) {
            jQuery('ul.all_product-lists').show();
            $listItems.each(function() {
                var listItemText = jQuery(this).text().toLowerCase();
                if (listItemText.includes(searchText)) {
                    var this_field = jQuery(this);
                    var this_field_class = jQuery(this).attr('class');

                    if(this_field_class == selectedCategory || selectedCategory=='All category'){
                        this_field.show();
                         anyMatched = true;
                    }else{
                        this_field.hide();
                    }

                } else {
                    jQuery(this).hide();
                }
            });
           if (!anyMatched) {
                jQuery('ul.all_product-lists').append('<li>No results found</li>');
            }
        } 
    });
  /* Get a quote js */
  jQuery(document).on('click','#cstm_quote_bton',function(){
		jQuery('.product__info-container.product__column-sticky .shopify-block.shopify-app-block').addClass('custom-css-data');
        jQuery('.custom-css-data').removeClass('xlose-frm');
	});
  jQuery('.storeify-form-action-quote').before("<div class='logo-img-frm'><img src='https://cdn.shopify.com/s/files/1/0750/4252/1376/files/GlitterBee3_d9be9a78-2d65-4134-b41e-672aa2870abd.png?v=1682543183'></div>");
  
      jQuery('.storeify-form-action-quote').before("<div class='close-popup-form'><i class='fa-solid fa-x'></i></div>");
    jQuery('.close-popup-form').on('click',function(){
      jQuery('.custom-css-data').addClass('xlose-frm');
  });
  var socialmediahtml = jQuery('.social-media-text').html();
    jQuery('.storeify-foooter-frm .storeify-submit-frm').after(socialmediahtml);
    jQuery('.storeify-requestaquote .storeify-requestaquote-mes').after('<div class="continueshoping"><a class="cta" href="/#wholesale">Continue Shoping</a></div>');
    jQuery('.continueshoping').css('display','none');
  function checkForSuccessMessage() {
        if (jQuery('.storeify-mes-success').length > 0) {
           jQuery('.continueshoping').css('display', 'block');
            clearInterval(intervalID);
        }
    }

    var intervalID = setInterval(checkForSuccessMessage, 1000);
  /* images swatch*/
      
     $('.color-swatch').on('click', function() {
     setTimeout(function() {
       var buttonIMG = $('.thumbnail[aria-current="true"]');
        var imgSrc = buttonIMG.find('img').attr('src');
        var imageElement = $('li.slider__slide.is-active .product__media.media.media--transparent img').attr('src', imgSrc);
    }, 100);
    });
});


